module.exports = __webpack_public_path__ + "img/c20.8b3aa0a3.png";